// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"ef57c66a","70":"30f815a1","139":"d03eea9a","253":"c06af10f","396":"2e373897","560":"d957cd07","801":"d36f48cf","865":"a202ad97"}[chunkId] + ".chunk.js";
};